import { render } from "./TabMenu.vue?vue&type=template&id=7bea6c7e&scoped=true"
import script from "./TabMenu.vue?vue&type=script&lang=js"
export * from "./TabMenu.vue?vue&type=script&lang=js"

import "./TabMenu.vue?vue&type=style&index=0&id=7bea6c7e&scoped=true&lang=css"

import exportComponent from "/Users/pongsakornsomsri/workspace/neera-retreat-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bea6c7e"]])

export default __exports__